import MESSAGES from 'constants/messages';
import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';
import { OnCheckDictionaryName } from '../../types';

type Validate = (
  field: string,
  onCheckDictionaryName: OnCheckDictionaryName,
) => Promise<string>;

const validate: Validate = async (dictionaryName, onCheckDictionaryName) => {
  if (!dictionaryName || stringIsInvalid(dictionaryName)) {
    return MESSAGES.DICTIONARIES.NAME.REGEX;
  }

  if (stringMaxLengthIsInvalid(dictionaryName)) {
    return MESSAGES.DICTIONARIES.NAME.MAX_LENGTH;
  }
  try {
    await onCheckDictionaryName('dictionaryName', dictionaryName);
  } catch ({ dictionaryName: errorMessage }) {
    return errorMessage;
  }

  return undefined;
};

export default validate;
